<template>
    <div class="flex middle">
        <h2 id="propertyDetailTitle" class="f4 wrap text-bold singleline">{{molang('dpp.propertyDetails.propertyDetailsHeader')}}</h2>
        <template v-if="newSoldPublicRecordCta && !dpp.isActive">
            <a v-if="isDigsSubscribed" class="btn secondary small" :href="goToDashboard">Owner Dashboard</a>
            <button type="button" v-else class="btn secondary small" @click="openDig()">{{ molang('dpp.hotButton.iAmOwner') }}</button>
        </template>
    </div>
    <table class="dpp-records">
        <tbody>
            <tr v-if="getEstimatePriceRange">
                <td>
                    <i class="icon-logo-m-new"></i>
                    <span class="underdash" role="button" @click="openDisclaimer">Movoto {{molang('dpp.estimate')}}</span>
                    <b class="link" v-scroll="'propertyEstimatePanel'" role="button">{{getEstimatePriceRange}}</b>
                    <sub v-if="showNotSupportedByMLS()">
                        {{molang('dpp.movotoCalculated')}}
                    </sub>
                </td>
            </tr>
            <tr  v-if="dpp.hoafee">
                <td>
                    <i class="icon-hand-house"></i>
                    <span>{{molang('dpp.propertyDetails.hoaFees')}}</span>
                    <b>
                        {{$filters.formatPrice(dpp.hoafee)}}{{perHOAUnit()}}
                    </b>
                </td>
            </tr>
            <tr v-if="dpp.lotSize">
                <td>
                    <i class="icon-size"></i>
                    <span>{{molang('dpp.propertyDetails.lotSize')}}</span>
                    <b>
                        {{$filters.formatFriendlyLotSize(dpp.lotSize, dpp.lotSizeUnit)}}
                    </b>
                </td>
            </tr>
            <tr v-if="dpp.yearBuilt">
                <td>
                    <i class="icon-year-built"></i>
                    <span>{{molang('dpp.propertyDetails.yearBuilt')}}</span>
                    <b>
                        {{ dpp.yearBuilt || '—' }}
                    </b>
                </td>
            </tr>
            <tr v-if="dpp.garage">
                <td>
                    <i class="icon-car"></i>
                    <span>{{molang('dpp.propertyDetails.garageSpaces')}}</span>
                    <b>
                        {{ dpp.garage}}
                    </b>
                </td>
            </tr>
            <tr v-if="dpp.geo.neighborhood">
                <td>
                    <i class="icon-user-group"></i>
                    <span>{{molang('dpp.propertyDetails.neighborhood')}}</span>
                    <a class="link" v-if="dpp.geo.neighborhoodPath" :href="glb.appUrl + dpp.geo.neighborhoodPath">
                        {{dpp.geo.neighborhood}}
                    </a>
                    <b v-else>
                        {{dpp.geo.neighborhood}}
                    </b>
                </td>
            </tr>
            <tr v-if="dpp.nearbySchoolAvgRating">
                <td>
                    <i class="icon-cap"></i>
                    <span>
                        GreatSchool Score
                    </span>
                    <b @click="openSchool" v-scroll="'locationPanel'" class="link" role="button">
                        {{`${dpp.nearbySchoolAvgRating.min}/10 to ${dpp.nearbySchoolAvgRating.max}/10`}}
                    </b>
                </td>
            </tr>
            <tr v-if="getEstRentFee && getEstRentFee.value && !hideEstMonthCost">
                <td>
                    <i class="icon-investment"></i>
                    <span>Rental Estimate</span>
                    <b type="button" class="link" v-scroll="'propertyEstimatePanel'" role="button">{{$filters.formatPrice(getEstRentFee.value)}}/Month</b>
                </td>
            </tr>
            <tr v-if="getMortgagePerMonth">
                <td>
                    <i class="icon-calculator"></i>
                    <span>{{molang('dpp.propertyDetails.mortgagePayment')}}</span>
                    <b class="link" v-scroll="'propertyMortgagePanel'" role="button">{{$filters.formatPrice(getMortgagePerMonth)}}/Month</b>
                </td>
            </tr>
            <tr class="full" v-if="!hasOJOAgent && getSplit('movoto-cta-move-CW-3672')">
                <td class="full">
                    <button type="button" v-if="!dpp.listingByMovoto && !dpp.isNHS && !dpp.isRDC" class="btn secondary small w-100"  @click="openHotlead(secondaryCtaTxt)"><i class="icon-comment"></i> {{secondaryCtaTxt}} </button>
                </td>
            </tr>
            <tr v-else-if="preApprovalButtonObj">
                <td class="full">
                    <button class="btn primary small w-100" @click="showForm(preApprovalButtonObj)" type="button"><i class="icon-money"></i> {{preApprovalButtonObj.cta}}</button>
                </td>
            </tr>
            <SplitTreatments v-if="dpp.isFrontier" :names="['movoto-CW-2946']">
                <template #default="{ treatments, isReady }">
                    <tr v-if="isReady && (treatments['movoto-CW-2946'] === 'on')">
                        <td id="ads-col">
                            <i class="icon-wifi"></i>
                            <span>Internet</span>
                            <mvtAds id="ads-badge-frontier" :options="{type:'badge', name: 'frontier'}" ></mvtAds>
                        </td>
                    </tr>
                </template>
            </SplitTreatments>
        </tbody>
    </table>
</template>
<script src="./property-baserecord.js"></script>

<style lang="scss">
@use './property-baserecord.scss' as *;
</style>

